import { useEffect, useState, useRef } from "react";
import msalInstance from "../config/authProvider";
import { safeLocalStorage } from "./safeLocalStorage";

/**
 * Signs the user in via MSAL. There is deliberately no opt-out: every route,
 * including the `/design` prototype, goes through this.
 */
export default function useAuthenticateUser() {
  const [authenticate, setAuthenticate] = useState({ isAuthenticated: false, account: ""});
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true; // Run doAuth once to prevent weird login looping behavior

    const doAuth = async () => {
      try {
        await msalInstance.initialize();

        const result = await msalInstance.handleRedirectPromise();
        const account = result?.account || msalInstance.getAllAccounts()[0];

        if (!account) {
          await msalInstance.loginRedirect({ scopes: ["user.read"] });
          return;
        }

        const response = await msalInstance.acquireTokenSilent({
          scopes: ["user.read"],
          account,
        });

        if (response.accessToken) {
          safeLocalStorage.set("token", response.accessToken);
          setAuthenticate({
            isAuthenticated: true,
            account: account.username,
          });
        } else {
          setAuthenticate({
            isAuthenticated: false,
            account: "No access token",
          });
        }
      } catch (err: any) {
        console.error("MSAL error:", err);
        if (
          err.errorCode === "interaction_required" ||
          err.errorCode === "no_account_in_silent_request"
        ) {
          await msalInstance.loginRedirect({ scopes: ["user.read"] });
        }
      }
    };

    doAuth();
  }, []);

  return { authenticate };
}